module.exports = __webpack_public_path__ + "img/reward-bg.ffbd9f15.png";